var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path6, _rect2, _path7, _rect3, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 152,
    viewBox: "0 0 290 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 100C166.51 100 188 78.5097 188 52C188 25.4903 166.51 4 140 4C113.49 4 92 25.4903 92 52C92 78.5097 113.49 100 140 100Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171 139C195.301 139 215 119.301 215 95C215 70.6995 195.301 51 171 51C146.699 51 127 70.6995 127 95C127 119.301 146.699 139 171 139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 124C146.719 124 170 100.719 170 72C170 43.2812 146.719 20 118 20C89.2812 20 66 43.2812 66 72C66 100.719 89.2812 124 118 124Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140 152C168.719 152 192 128.719 192 100C192 71.2812 168.719 48 140 48C111.281 48 88 71.2812 88 100C88 128.719 111.281 152 140 152Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177 107C203.51 107 225 85.5097 225 59C225 32.4903 203.51 11 177 11C150.49 11 129 32.4903 129 59C129 85.5097 150.49 107 177 107Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 59,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 92,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 6,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 141.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 143.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 23,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#006FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.372 76.7629H124.979L134.021 100.365H145.477L157.968 67.9675L161.368 58.9996L163.56 63.7792L169.794 60.9952L162.132 44.3652L145.28 51.7563L148.113 57.9156L153.04 55.7476L148.359 67.869L140.18 89.1554L132.616 67.9429H120.298L120.372 76.7629Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 76,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#006FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.527 96.6775H243.299L246.777 105.755H251.183L255.987 93.2946L257.295 89.8454L258.138 91.6837L260.536 90.613L257.589 84.2168L251.107 87.0595L252.197 89.4285L254.092 88.5946L252.292 93.2567L249.146 101.444L246.237 93.2851H241.499L241.527 96.6775Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 5.85352,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-6 0 5.85352)",
    fill: "#006FFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6834 33.103L20.1505 32.8437L26.321 44.9741L32.4559 44.3293L37.3215 26.2769L38.6374 21.2831L40.0807 23.7192L43.2619 21.8775L38.2227 13.4032L29.6145 18.3097L31.4784 21.4486L33.995 20.0103L32.1705 26.7649L28.9884 38.6244L23.7441 27.6906L17.1474 28.3839L17.6834 33.103Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 36L264 31",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32 126L56 118.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.a037489e4c2551cbf1e8b292114c6146.svg";
export { ForwardRef as ReactComponent };